import { createContext, type ReactNode, useContext, useState } from "react";

const SidebarContext = createContext({ collapsed: false, setCollapsed: (_: boolean) => {} });
export const useSidebar = () => useContext(SidebarContext);
export function SidebarProvider({ children }: { children: ReactNode }) {
  const [collapsed, setCollapsed] = useState(false);
  return <SidebarContext value={{ collapsed, setCollapsed }}>{children}</SidebarContext>;
}
